 export default [
  // const routes = [
  {
    path: "/home",
    name: "首页展示",
    iconClass: "el-icon-s-home",
    component: () => import("@/components/HomeCustomer"),
    meta: { menuShow: false },
  },
  {
    path: "/devices",
    name: "设备管理",
    iconClass: "el-icon-document",
    component: () => import("@/components/devices/DeviceListCustomer"),
    meta: { menuShow: false },
    children: [
      {
        path: "/devices/:deviceId",
        component: () => import("@/components/show/DeviceInfo"),
        meta: { menuShow: false },
      },
    ],
  },
  {
    path: "/details",
    name: "详细数据",
    iconClass: "el-icon-info",
    component: () => import("@/components/details/ShowA1Customer"),
    meta: { menuShow: false },
    children: [
      {
        path: "/details/:deviceId",
        component: () => import("@/components/show/DeviceInfo"),
        meta: { menuShow: false },
      },
    ],
  },
];
// // 递归处理嵌套的子路由的 path 属性
// const addPrefixToRoutes = (routes, prefix) => {
//   return routes.map((route) => {
//     const modifiedRoute = {
//       ...route,
//       path: `${prefix}${route.path}`,
//     };
//     if (route.children) {
//       modifiedRoute.children = addPrefixToRoutes(route.children, `${prefix}`);
//     }
//     return modifiedRoute;
//   });
// };

// const prefixedRoutes = addPrefixToRoutes(routes, "/en");

// export default prefixedRoutes;
